import { render, staticRenderFns } from "./CardMaisEmolumentos.vue?vue&type=template&id=3f8b696e&scoped=true&"
import script from "./CardMaisEmolumentos.vue?vue&type=script&lang=js&"
export * from "./CardMaisEmolumentos.vue?vue&type=script&lang=js&"
import style0 from "./CardMaisEmolumentos.vue?vue&type=style&index=0&id=3f8b696e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b696e",
  null
  
)

export default component.exports